import React, { useCallback } from "react";
import { useParams } from "react-router-dom";
import { useQueryParams, StringParam, withDefault } from "use-query-params";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { useUpgradeMutation } from "@api/flatRateBilling.api";
import { useScope } from "@state/scopeContext.lib";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import { useEffectOnce } from "@hooks/useEffectOnce";
import { useBillingStatus } from "@hooks/useBillingStatus";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";

interface CheckoutRouteParams {
    plan: FLAT_RATE_PLANS;
}

export const Upgrade: React.FC = () => {
    const navigate = useStateAwareNavigate();
    const { plan } = useParams() as Readonly<CheckoutRouteParams>;
    const [{ after: afterCheckoutUrl, code, intent: intentId }] =
        useQueryParams({
            after: StringParam,
            code: withDefault(StringParam, undefined),
            intent: withDefault(StringParam, undefined),
        });

    const { query } = useBillingStatus();
    const afterCheckout = useCallback(async () => {
        await query.refetch();
        navigate(afterCheckoutUrl ?? "/settings/billing");
    }, [afterCheckoutUrl, navigate, query]);

    const { activeWorkspaceKey } = useScope();
    const subscribeMutation = useUpgradeMutation(
        activeWorkspaceKey,
        afterCheckout,
    );

    useEffectOnce(() => {
        subscribeMutation.mutate({
            plan,
            code,
            intentId,
        });
    });

    return <PageCoverLoader>Starting autopilot</PageCoverLoader>;
};
